import React, { useState, useEffect } from "react";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { useAuth } from '../context/AuthContext';
import { TextField, Button, Paper, Typography, InputAdornment, IconButton, Box, Alert } from "@mui/material";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import LoginIcon from '@mui/icons-material/Login';

const isLocal = window.location.hostname === 'localhost';
const apiPrefix = isLocal ? '' : '/api';

const LoginScreen = () => {
  const navigate = useNavigate();
  const { refreshAuth } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => { document.title = 'Media Scanner'; }, []);

  const [errorMessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem('sessionExpired')) {
      setErrorMessage('Sesija je istekla. Prijavite se ponovo.');
      sessionStorage.removeItem('sessionExpired');
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(apiPrefix + '/login', { "username": email, "password": password });
      if (response.status === 200 && response.data !== null) {
        await refreshAuth();
        navigate("/main");
      }
    } catch (error) {
      if (error.response) {
        setErrorMessage("Pogrešno korisničko ime ili lozinka");
      } else if (error.request) {
        console.error("Nema odgovora sa servera");
      } else {
        console.error("Greška kod postavljanja zahtjeva: ", error.message);
      }
    }
  }

  return (
    <Box sx={{
      minHeight: '100vh',
      backgroundColor: '#f5f7fa',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <Paper elevation={3} sx={{ p: 5, borderRadius: 2, width: '100%', maxWidth: 420 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, color: '#0079bf', mb: 0.5, textAlign: 'center' }}>
          Media Scanner
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4, textAlign: 'center' }}>
          Prijavite se za nastavak
        </Typography>

        <form onSubmit={handleSubmit}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            size="small"
            id="email"
            label="Email adresa"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            size="small"
            name="password"
            label="Lozinka"
            type={showPassword ? 'text' : 'password'}
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(v => !v)} edge="end" size="small">
                    {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          {errorMessage && (
            <Alert severity="error" sx={{ mt: 1 }}>
              {errorMessage}
            </Alert>
          )}

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            endIcon={<LoginIcon />}
            sx={{ mt: 3, py: 1 }}
          >
            Prijava
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default LoginScreen;
